const truncateFileName = (name: string, maxChars = 8): string => {
  const lastDot = name.lastIndexOf('.');
  const baseName = lastDot !== -1 ? name.slice(0, lastDot) : name;
  const ext = lastDot !== -1 ? name.slice(lastDot) : '';
  if (baseName.length <= maxChars) return name;
  return `${baseName.slice(0, maxChars)}...${ext}`;
};

export default truncateFileName;
